export const MAX_DEPOSIT_INVOICE_PERCENT = 100
